export default __webpack_public_path__ + "static/media/baseline-keyboard_arrow_up-24px.70840a1e.svg";